import "./App.css";
import { Routes, Route } from "react-router-dom";

import NavBar from "./NavBar";
import Footer from "./Footer";

import Homepage from "./Homepage";
import About from "./About";
import Work from "./Work";
import Contact from "./Contact";

export default function App() {
  return (
    <>
      <NavBar />

      <main className="page-content">
        <Routes>
          <Route path="/" element={<Homepage />} />

          <Route path="/about" element={<About />} />

          <Route path="/work" element={<Work />} />

          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      <Footer />
    </>
  );
}
